import Interaction from 'ol/interaction/Interaction';
import InteractionProperty from 'ol/interaction/Property.js';
import { MapProperty } from 'cadenza/map/map-property';

/**
 * Dummy interaction class that does nothing when added to map or activated - it serves as a wrapper object for its key (id of the wps control button).
 * Real map interactions (draw, modify, select) are set and activated directly inside wps module.
 */
export class WpsInteraction extends Interaction {

  constructor (options = {}) {
    super(options);
    this._key = options.key;
    this._map = options.map;
  }

  get key () {
    return this._key;
  }

  setActive (active) {
    this.set(InteractionProperty.ACTIVE, false);
    if (this._map) {
      this._toggleSelectContextMenu(!active);
    }
  }

  _toggleSelectContextMenu (isSelectContextMenuEnabled) {
    if (!isSelectContextMenuEnabled) {
      this._isSelectContextMenuEnabled = this._map.get(MapProperty.CONTEXT_MENU_ENABLED);
      this._map.set(MapProperty.CONTEXT_MENU_ENABLED, false);
    } else {
      this._map.set(MapProperty.CONTEXT_MENU_ENABLED, this._isSelectContextMenuEnabled);
    }
  }

}
